import type { TransitionConfig, TransitionContext } from '../config/types';

export const getResolvedConfig = (config: TransitionConfig, context: TransitionContext) => {
  const resolvedTitle = typeof config.title === 'function' ? config.title(context) : config.title;
  const resolvedContent = typeof config.content === 'function' ? config.content(context) : config.content;
  const resolvedConfirmText =
    typeof config.buttons.confirm.text === 'function'
      ? config.buttons.confirm.text(context)
      : config.buttons.confirm.text;

  return {
    title: resolvedTitle,
    content: resolvedContent,
    confirmText: resolvedConfirmText,
  };
};
